import * as z from "zod";
import { SectionType } from "../enums/database-enums";
import { StorefrontPageSectionDataSchema, StorefrontPageSectionSchema } from "./section-base";

export const StorefrontSectionRefSchema = StorefrontPageSectionSchema.extend({
  type: z.literal(SectionType.SECTION_REF),
  data: StorefrontPageSectionDataSchema,
});

export type StorefrontSectionRef = z.infer<typeof StorefrontSectionRefSchema>;
